module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_0.ef16e078.png";